/**
 * The two numbers a section's desktop layout is built from. A LEAF module for the same reason as
 * `scrollable-area-class.ts`: the pending UIs need them and live in the entry bundle, so importing them from
 * `layout.tsx` would drag TitleSection and the nav stack in with them (+8.5 KB gzip on vendor-tanstack).
 * `layout.tsx` re-exports both, so nothing else has to know this file exists.
 */

/**
 * The width of an expanded list pane, and the one geometry a list has: the same 450px it keeps once a record
 * is open (`--sip-left` in employees.tsx, `expandedWidth` in collapsible-panel.tsx). Full-width before a
 * selection left the rows in a 450px column of an unbounded pane, with the toolbar's rule running past them
 * and the scroll living only over that column — the blank half looked like the page and would not scroll.
 */
export const LIST_PANE_WIDTH = 'min(450px, 100%)'

/**
 * A column that holds the viewport while the page scrolls past it: the lists either side of a report stay put,
 * and the report is what makes the page tall. `top-33` clears the topbar (h-18) and the title row beneath it.
 * Desktop only — in a nav stack each level already owns the whole screen (see useStackedLayout).
 */
export const PINNED_COLUMN =
  'md:sticky md:top-[var(--chrome-stack)] md:h-[calc(100dvh-var(--chrome-stack))] print:static print:h-auto'

/** What a list pane squashes to once a record is open; `layout.tsx` spells it as `--clp-collapsed`/`--sip-left`, which Tailwind's scanner has to see literally. */
export const RAIL_WIDTH = '52px'
